module.exports = __webpack_public_path__ + "img/img11.2155e32b.png";